// The check-out form submits to two endpoints: the custom question answers go to the
// question responses endpoint and everything else goes up with the trip. These helpers
// decide which values belong where.

// Photos are uploaded to the server as soon as they are picked, so they are never part of
// either payload. The abuse/defect photos are frontend-owned: they're injected by the
// root_cause_details slot rather than described in the backend `fields` list, so their names
// live here. Every other (backend-described) photo field is discovered from the form
// description and passed in as `photoFieldNames`, so a new backend photo field is excluded
// without editing this file.
const ROOT_CAUSE_PHOTO_FIELDS = ['abusePhotos', 'defectPhotos']

export function splitCheckOutFormValues(
  formValues,
  {
    photoFieldNames = [],
    questionFieldNames = [],
    keepAbuseNeglectClaims = true,
  } = {}
) {
  const excludedFromTrip = [
    ...ROOT_CAUSE_PHOTO_FIELDS,
    ...photoFieldNames,
    ...questionFieldNames,
    // abuseNeglectClaims only applies to the neglect and defect root causes.
    ...(keepAbuseNeglectClaims ? [] : ['abuseNeglectClaims']),
  ]

  return Object.keys(formValues).reduce(
    (payloads, key) => {
      if (questionFieldNames.includes(key)) {
        payloads.questionValues[key] = formValues[key]
      } else if (!excludedFromTrip.includes(key)) {
        payloads.tripValues[key] = formValues[key]
      }
      return payloads
    },
    { tripValues: {}, questionValues: {} }
  )
}
